/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/add'
export default icon
